// Generated by CoffeeScript 2.7.0
var SettingsBasic;

import BasicMixin from '../settings_basic/mixin.js';

export default SettingsBasic = Vue.extend({
  mixins: [BasicMixin],
  props: {
    activeTab: {
      type: String
    },
    settingsData: {
      type: Object
    }
  },
  data: function() {
    return {
      settings: this._generateSettings(),
      imageFields: this._generateImageFields(),
      wechatMessageEncrypt: {
        enable: false,
        encoding_aes_key: ''
      },
      valid: true
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="content-container">

      <div class="form-field-group inline">
        <div class="form-field required"
             :class="{ 'has-error': !settings.name }">
          <div class="form-field-head">
            <div class="form-field-title">空间名称</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input v-model="settings.name"
                     class="form-field-value"
                     type="text"
                     placeholder="请输入" >
            </div>
            <div class="message">不能为空</div>
          </div>
        </div>
        <div class="form-field">
        </div>
      </div>

      <div class="form-field-group attachments-field inline">
        <image-field  v-for="(field, index) in imageFields"
                      :key="index"
                      :attr="field.key"
                      :url="field.url"
                      :helperText="field.helperText"
                      :title="field.title"
                      :hasDelete="field.delete"
                      @imageChanged="imageChanged"/>
      </div>

      <field-list :fields="baseAttributefields"
                  :response="baseAttributeResponse"
                  :entries="baseAttributeResponse.entries"
                  :editing="true"
                  extendClass="first-field-group field-list-two-item"
                  ref="baseAttributesRef" />

      <div class="form-field-group inline">
        <div class="form-field required">
          <div class="form-field-head">
            <div class="form-field-title head-with-btn">
              <div>Token</div>
              <button class="refresh-token btn-small" @click="refreshToken">刷新Token</button>
            </div>
          </div>
          <input class="form-field-value" disabled v-model.trim="settings.token" type="text">
        </div>

        <div class="form-field">
          <div class="form-field-container"
               :disabled="!settings.wechat_message_encrypt.enable">
            <div class="form-field-head">
              <div class="form-field-title head-with-btn">
                <div class="title-text">EncodingAESKey</div>
                <div class="head-btn inline">
                  <div class="form-field-head">
                    <div class="form-field-title">被动回复消息加密</div>
                  </div>
                  <label class="switch js-switch">
                    <input v-model="settings.wechat_message_encrypt.enable"
                            class="js-switch-input"
                            type="checkbox">
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-field-input-container">
              <div class="form-field-input">
                <input v-model="settings.wechat_message_encrypt.encoding_aes_key"
                       class="form-field-value"
                       :disabled="!settings.wechat_message_encrypt.enable"
                       placeholder="请输入"
                       type="text">
              </div>
              <div class="message"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-field-group bottom-form-field inline">
        <attachment-field :attachment="settings.domain_verify_file"
                          fieldTitle="域名认证"
                          dataKey="domain_verify_file"
                          requestUrl="/admin/settings/basic.json"
                          acceptType="text/plain"
                          fileExtension="text"
                          :fieldMessage="fieldMessage" />
      </div>
    </div>
    <div class="content-footer">
      <button class="content-footer-btn"
              :disabled="!valid"
              @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  computed: {
    fieldMessage: function() {
      return '（微信设置域名处请填写： beta.skylarkly.com （如：业务域名，JS接口安全域名，网页授权域名））';
    }
  },
  methods: {
    updateSettings: function() {
      var entries;
      entries = this.$refs.baseAttributesRef.getEntries();
      if (!(this.$refs.baseAttributesRef.valid && Boolean(this.settings.name))) {
        return;
      }
      this.valid = false;
      this._transferEntries(entries);
      return Skylark.Libs.Ajax.patch('/admin/settings/basic.json', {
        data: this.getData(),
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, err) {
          return Skylark.Bridge.newAlertify('', {
            type: 'danger'
          });
        },
        complete: () => {
          return this.valid = true;
        }
      });
    },
    getData: function() {
      var data;
      data = {
        namespace: {}
      };
      _.each(this.settings, function(item, key) {
        if (item instanceof Object) {
          data.namespace[key] = {};
          return _.each(item, function(value, key1) {
            return data.namespace[key][key1] = value;
          });
        } else {
          return data.namespace[key] = item;
        }
      });
      return data;
    }
  }
});
